<script setup lang="ts">
// Fetch categories for navigation
const { data: categories } = await useFetch('/api/categories')

// Transform categories into navigation format with console log
const categoryNavigation = computed(() => {
  console.log('Categories:', categories.value) // Debug log
  return (
    categories.value?.map((cat) => ({
      label: `${cat.icon} ${cat.name}`, // Combine emoji and name in the label
      to: `/${cat.slug}`,
    })) || []
  )
})
</script>

<template>
  <UHeader>
    <template #logo>
      <AppBrand tag="h1" emoji="🧑‍🚀" />
      <UBadge
        label="Newsletter"
        variant="subtle"
        class="mb-0.5 hidden sm:inline-flex"
      />
    </template>

    <template #right>
      <UButton v-if="false" label="Advertise" color="gray" to="/pricing" />
      <UButton
        label="All Newsletters"
        icon="i-heroicons-arrow-right-20-solid"
        trailing
        color="black"
        to="/newsletters"
        class="hidden lg:flex"
        data-testid="all-newsletters-button"
      />
    </template>

    <template #panel>
      <div class="space-y-4">
        <h2 class="font-semibold text-lg">Our Newsletters</h2>
        <UNavigationTree
          :links="categoryNavigation"
          default-open
          class="w-full"
        />
      </div>
    </template>
  </UHeader>
</template>
